export type PaymentConfigurationField = { id: string; name: string; type?: 'boolean' };

/** Configuration fields of the payment methods that need them, by payment method type (name is an i18n key) */
export const PAYMENT_CONFIGURATION_FIELDS: Record<number, PaymentConfigurationField[]> = {
    37: [
        { id: 'merchantId', name: 'SETTINGS.PAYMENT_METHODS.REDSYS.MERCHANT_ID' },
        { id: 'terminalId', name: 'SETTINGS.PAYMENT_METHODS.REDSYS.TERMINAL_ID' },
        { id: 'signature', name: 'SETTINGS.PAYMENT_METHODS.REDSYS.SIGNATURE' },
        { id: 'port', name: 'SETTINGS.PAYMENT_METHODS.REDSYS.PORT' },
        { id: 'version', name: 'SETTINGS.PAYMENT_METHODS.REDSYS.VERSION' }
    ],
    42: [
        { id: 'useTip', name: 'SETTINGS.PAYMENT_METHODS.ZPAY_BRIDGE.USE_TIP', type: 'boolean' }
    ],
    44: [
        { id: 'publicKey', name: 'SETTINGS.PAYMENT_METHODS.ZPAY_SOFTPOS.PUBLIC_KEY' },
        { id: 'terminalId', name: 'SETTINGS.PAYMENT_METHODS.ZPAY_SOFTPOS.TERMINAL_ID' }
    ],
    45: [
        { id: 'apiKey', name: 'SETTINGS.PAYMENT_METHODS.ADYEN.API_KEY' },
        { id: 'apiUrl', name: 'SETTINGS.PAYMENT_METHODS.ADYEN.API_URL' },
        { id: 'deviceId', name: 'SETTINGS.PAYMENT_METHODS.ADYEN.DEVICE_ID' },
        { id: 'merchantAccount', name: 'SETTINGS.PAYMENT_METHODS.ADYEN.MERCHANT_ACCOUNT' }
    ],
    46: [
        { id: 'merchantKey', name: 'SETTINGS.PAYMENT_METHODS.ZPAY.MERCHANT_KEY' },
        { id: 'terminalId', name: 'SETTINGS.PAYMENT_METHODS.ZPAY.TERMINAL_ID' },
        { id: 'useTip', name: 'SETTINGS.PAYMENT_METHODS.ZPAY_BRIDGE.USE_TIP', type: 'boolean' }
    ]
};
